import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import useCreadyApi from "../../utils/Api";

const FortnoxFinalize = () => {
  const api = useCreadyApi();
  const navigate = useNavigate();
  const [status, setStatus] = useState("pending"); // pending, success, error
  const [message, setMessage] = useState("");
  const apiCallMade = useRef(false);

  useEffect(() => {
    
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const finalizeIntegration = async () => {
      if (apiCallMade.current) {
        return;
      }

      const queryParams = new URLSearchParams(window.location.search);
      const code = queryParams.get("code");
      const state = queryParams.get("state");

      if (!code || !state) {
        setStatus("error");
        setMessage("Saknade parametrar. Integreringen kunde inte slutföras.");
        return;
      }

      try {
          apiCallMade.current = true;
          const result = await api.fortnox.finalize([{ code}, {state }]);

          await sleep(2000);

          if (result?.errorMessage) {
            setStatus("error");
            setMessage(result.errorMessage);
            return;
          }

          setStatus("success");
          setMessage("Integrationen med Fortnox har slutförts!");
      } catch (error) {
        await sleep(2000);
        setStatus("error");
        setMessage("Ett fel inträffade vid integreringen med Fortnox.");
      }
    };

    finalizeIntegration();
  }, [api, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      {status === "pending" && (
        <p className="text-gray-600">Slutför kopplingen...</p>
      )}
      
      {status === "success" && (
        <div className="text-center">
          <div className="mb-4 text-green-600 text-xl font-medium">{message}</div>
          <Link 
            to="/integrations" 
           className="inline-block px-6 py-2.5 text-m font-semibold text-center hover:text-blue-1 bg-blue-1 align-middle transition-all duration-100 ease-in-out hover:bg-transparent border-2 border-blue-1 border-solid rounded-md cursor-pointer text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1"
          >
            Gå till Integrationer
          </Link>
        </div>
      )}
      
      {status === "error" && (
        <div className="text-center">
          <div className="mb-4 text-red-600 text-xl font-medium">{message}</div>
          <Link 
            to="/integrations" 
            className="inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Gå till Integrationer
          </Link>
        </div>
      )}
    </div>
  );
  
};

export default FortnoxFinalize;
